import { AnimatePresence } from 'motion/react';
import { colors } from '@/theme/colors';
import { DrawerDialog, DrawerDialogProps } from '@/common/components/drawer-dialog';
import FilterPill from './filter-pill';
import Pin from '@/icons/pin';
import StepZipcode, { StepZipcodeProps } from './intro-modal/step-zipcode';
import { cn } from '@/shadcn-ui/utils';

export interface FilterZipcodeDrawerDialogProps
  extends DrawerDialogProps,
    StepZipcodeProps {
  handleOpen: () => void;
  dark?: boolean;
  pillClassName?: string;
}

export default function FilterZipcodeDrawerDialog({
  selectedZipcode,
  submitZipcode,
  open,
  handleOpen,
  handleClose,
  dark = false,
  pillClassName,
}: FilterZipcodeDrawerDialogProps) {
  return (
    <>
      <AnimatePresence>
        {selectedZipcode ? (
          <FilterPill
            onClick={handleOpen}
            icon={<Pin fillPrimary={dark ? colors.neutral100 : colors.neutral1} />}
            text={selectedZipcode}
            className={cn('rounded-lg border-none px-3', pillClassName)}
            dark={dark}
          />
        ) : null}
      </AnimatePresence>

      <DrawerDialog
        open={open}
        handleClose={handleClose}
        repositionInputs={false}
        title="Find Flexcars near you"
      >
        <StepZipcode
          selectedZipcode={selectedZipcode}
          submitZipcode={submitZipcode}
          multiStep={false}
        />
      </DrawerDialog>
    </>
  );
}
